import { css } from '@emotion/core'
import { colors } from 'styles/variables'

export const link = css`
  color: ${colors.greens.green6};
  text-decoration: none;

  :visited {
    color: ${colors.greens.green6};
  }

  :hover {
    color: ${colors.primaries.primary4};
  }
`
